module.exports = __webpack_public_path__ + "img/representacion.df6666ff.png";